export default __webpack_public_path__ + "static/media/createAdmin.725108f7.png";